export const socialsData = {
    github: 'https://github.com/VishnuPScodes',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/vishnu-ps-699596174/',
    instagram: '',
    codepen: '',
    twitter: 'https://twitter.com/VISHNUP58826670',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@psvishnu373',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}